import React,{useState, useEffect} from 'react'
import { withRouter } from 'react-router-dom';
import {Box,Heading,Button} from 'grommet';
import {Notes,Redo} from 'grommet-icons';
import GetShipmentDocuments from '../../../components/getShipmentDocuments'
import GetS3Document from '../../../components/getS3Document'
import { LoadLayer, NavigationSnackBar, ReturnRowDir } from '../../../components/utils/shared/shared';
import { ReturnLocation,ReturnCollectionDetails } from '../../../components/utils/shared/shipmentViewFunctions';
import ShipmentBillingDetails from '../../../components/shipmentBillingDetails'
import { APIRequest } from '../../../components/utils/shared/requests';


function ShipmentViewCardHeader(props){
  // const page = (props.props.location.state === undefined ? 1 : props.props.location.state.page)
  // const startIndex = (props.props.location.state === undefined ? 1 : props.props.location.state.startIndex)
  // const endIndex = (props.props.location.state === undefined ? 10 : props.props.location.state.endIndex)
    // <Link to="/admin/shipments/all" search={`page=${page}`} state={{startIndex: startIndex,endIndex: endIndex}}><Button secondary hoverIndicator icon={<FormPrevious color={'brand'} />} /></Link>
    return (
      <Box justify='between' direction='row'><Box></Box><Box><Button hoverIndicator style={{zIndex: 10}} primary onClick={() => {props.props.history.push({pathname: '/shipment/new', reship:true, origin: props.shipment.origin, destination: props.shipment.destination, details:props.shipment.pieces})}}  size='small' label='Reship' icon={<Redo />}/></Box></Box>
    )
 
}

function BillingViewShipment(props) {    
  const [shipment, setShipment] = useState()
  const [load, setLoad] = useState(true)
  useEffect(() => { 
     APIRequest(`/shipments/${props.match.params.shipment_id}`).then(result => {setShipment(result); setLoad(false)})
   },[props]);
    return (
      <Box background={'light-2'}>
      <NavigationSnackBar title={`Shipment ${props.match.params.shipment_id}`} user={props.user} pages={[{name: 'Dashboard', link: '/dashboard'},{name: 'Billing List', link: '/billing/all'}]}  />
            {(load ? <LoadLayer load={load} label={'Loading...'}/>:
            <Box margin='small'>          
            <ShipmentViewCardHeader shipment={shipment} props={props} />
              <Box direction={ReturnRowDir(props.size)} margin='small' justify='between'><ReturnLocation location={shipment.origin} locationType={"Origin"} /><ReturnCollectionDetails shipment={shipment} props={props} setShipment={setShipment} /> <ReturnLocation location={shipment.destination} locationType={"Destination"} />  </Box>
                <Box direction='row' alignSelf='center' margin='small' overflow='scroll'>
                <ShipmentBillingDetails user={props.user} shipment={shipment} setShipment={setShipment} />
                </Box>
              <Box pad='small' margin='small' round elevation='medium' background={'background-front'}>
                <Box direction='row'><Notes color='brand' margin='small' /><Heading margin='small' level={4}>Documents</Heading></Box>
                <GetShipmentDocuments shipment={shipment} />
                <GetS3Document CommodityID={shipment.pieces.Packages[0].CommodityID} />
              </Box>
              </Box>

            )}
         </Box>
    )
  }

export default withRouter(BillingViewShipment)
